<template>
  <div class="pc-article">
    <div class="pc-article__body">
      <h3>Standbaupaket</h3>
    </div>
    <div class="pc-article__parent">
      <div>
        <img v-if="hasImage" :src="previewImage" alt="" class="pc-article__image">
      </div>
      <div class="pc-article__body">
        <span class="pc-article__title">{{ name }}</span>
        <article class="text-break">{{ description }}</article>
      </div>
    </div>
    <div class="pc-article__body">
      <hr>
      <h4 class="border--b-0">Grafische Gestaltung</h4>
      <table class="table mb-1">
        <thead>
          <th>Fläche</th>
          <th>Druckartikel</th>
          <th>Beschriftung / Grafikdatei</th>
        </thead>
        <tbody>
          <template v-for="group,gIndex in groupedRefinements" :key="gIndex">
            <print-job-booth-refinement-group v-if="group.length > 1"
              :group="group"
              @download="download"
              @show="showArticleModal">
            </print-job-booth-refinement-group>
            <print-job-booth-refinement v-else
              :refinement="group[0]"
              @download="download"
              @show="showArticleModal">
            </print-job-booth-refinement>
          </template>
          <tr>
            <td>Kommentar:</td>
            <td colspan="2">{{ printJob.comment }}</td>
          </tr>
        </tbody>

      </table>
    </div>

    <div class="pc-article__body">
      <hr class="mt-1">
      <h4 class="border--b-0">{{ $t('configurator.labels.booth_draft') }}</h4>
      <table class="table">
        <thead>
          <th>Datei</th>
        </thead>
        <tbody>
          <tr v-if="boothDraft">
            <td>
              <span v-if="cloud.status < PRINT_CLOUD_STATUS_FINISHED"
                class="text-primary cursor--pointer"
                @click="downloadBoothDraft">
                <i class="fa fa-download"></i> {{ boothDraft.original_name }}
              </span>
              <span v-else class="text-primary">{{ boothDraft.original_name }}</span>
            </td>
          </tr>
          <tr v-else>
            <td>
              <i>{{ $t('configurator.labels.no_booth_draft_uploaded') }}</i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <article-modal v-if="articleModalActive"
    :article="selectedArticle"
    @close="hideArticleModal">
  </article-modal>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useMainStore } from '@/store'
import { downloadFile } from '@/utils/file'
import { PRINT_CLOUD_STATUS_FINISHED } from '@/constants'
import { groupRefinements } from '@/utils/boothRefinements'

const store = useMainStore()
// define props
const props = defineProps({
  printJob: {
    type: Object,
    required: true,
  },
  articles: {
    type: Array,
    required: true,
  },
  booth: {
    type: Object,
    required: true,
  },
  boothType: {
    type: String,
    required: true,
  }
})
// define reactive props
const articleModalActive = ref(false)
const selectedArticle = ref(null)
// define computed props
const locale = computed(() => store.settings.locale)
const cloud = computed(() => store.tmp.cloud)
const exhibition = computed(() => store.tmp.exhibition_slug)
const boothDraft = computed(() => store.tmp.booth_draft)

const inEnglish = computed(() => {
  return locale.value === 'en'
})

const hasImage = computed(() => {
  if (props.booth.images.hasOwnProperty(props.boothType))
  return props.booth.images[props.boothType].length > 0
})

const previewImage = computed(() => {
  if (!hasImage.value) {
    // TODO: add fallback image
    return ''
  }

  return props.booth.images[props.boothType][0].imagePath
})

const name = computed(() => {
  return (inEnglish.value) ? props.booth.name_en : props.booth.name
})

const description = computed(() => {
  return (inEnglish.value) ? props.booth.description_en : props.booth.description
})

const printJobRefinements = computed(() => {
  return props.articles.filter((printArticle) => {
    return printArticle.booth_refinement_id !== null
  })
})

const groupedRefinements = computed(() => {
  if (printJobRefinements.value.length === 0) {
    return []
  }

  return groupRefinements(printJobRefinements.value)
})
// define methods
const showArticleModal = (article) => {
  selectedArticle.value = article
  articleModalActive.value = true
}

const hideArticleModal = () => {
  articleModalActive.value = false
  selectedArticle.value = null
}

const download = async (upload) => {
  await downloadFile(
    '/print/' + cloud.value.uuid + '/download/' + upload.id,
    upload.original_name
  )
}

const downloadBoothDraft = async () => {
  await downloadFile(
    '/print/' + cloud.value.uuid + '/booth-draft/' + boothDraft.value.identifier + '/download',
    boothDraft.value.original_name
  )
}
</script>